export const MOBILE_WIDTH_MD = 899;
export const MOBILE_WIDTH_999 = 999;
export const MOBILE_WIDTH_SM = 599;
